/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TokensRouteImport } from './routes/tokens'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as FilesIdRouteImport } from './routes/files.$id'
import { Route as FoldersIdRouteImport } from './routes/folders.$id'
import { Route as GroupsIndexRouteImport } from './routes/groups.index'
import { Route as GroupsIdRouteImport } from './routes/groups.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const TokensRoute = TokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const FilesIdRoute = FilesIdRouteImport.update({
  id: '/files/$id',
  path: '/files/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const FoldersIdRoute = FoldersIdRouteImport.update({
  id: '/folders/$id',
  path: '/folders/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GroupsIndexRoute = GroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const GroupsIdRoute = GroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/search': typeof SearchRoute
  '/tokens': typeof TokensRoute
  '/trash': typeof TrashRoute
  '/usage': typeof UsageRoute
  '/files/$id': typeof FilesIdRoute
  '/folders/$id': typeof FoldersIdRoute
  '/groups/$id': typeof GroupsIdRoute
  '/groups/': typeof GroupsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/search': typeof SearchRoute
  '/tokens': typeof TokensRoute
  '/trash': typeof TrashRoute
  '/usage': typeof UsageRoute
  '/files/$id': typeof FilesIdRoute
  '/folders/$id': typeof FoldersIdRoute
  '/groups/$id': typeof GroupsIdRoute
  '/groups': typeof GroupsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/search': typeof SearchRoute
  '/tokens': typeof TokensRoute
  '/trash': typeof TrashRoute
  '/usage': typeof UsageRoute
  '/files/$id': typeof FilesIdRoute
  '/folders/$id': typeof FoldersIdRoute
  '/groups/$id': typeof GroupsIdRoute
  '/groups/': typeof GroupsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/search'
    | '/tokens'
    | '/trash'
    | '/usage'
    | '/files/$id'
    | '/folders/$id'
    | '/groups/$id'
    | '/groups/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/search'
    | '/tokens'
    | '/trash'
    | '/usage'
    | '/files/$id'
    | '/folders/$id'
    | '/groups/$id'
    | '/groups'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/search'
    | '/tokens'
    | '/trash'
    | '/usage'
    | '/files/$id'
    | '/folders/$id'
    | '/groups/$id'
    | '/groups/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  SearchRoute: typeof SearchRoute
  TokensRoute: typeof TokensRoute
  TrashRoute: typeof TrashRoute
  UsageRoute: typeof UsageRoute
  FilesIdRoute: typeof FilesIdRoute
  FoldersIdRoute: typeof FoldersIdRoute
  GroupsIdRoute: typeof GroupsIdRoute
  GroupsIndexRoute: typeof GroupsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokens': {
      id: '/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof TokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/files/$id': {
      id: '/files/$id'
      path: '/files/$id'
      fullPath: '/files/$id'
      preLoaderRoute: typeof FilesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folders/$id': {
      id: '/folders/$id'
      path: '/folders/$id'
      fullPath: '/folders/$id'
      preLoaderRoute: typeof FoldersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groups/': {
      id: '/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof GroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groups/$id': {
      id: '/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof GroupsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  SearchRoute: SearchRoute,
  TokensRoute: TokensRoute,
  TrashRoute: TrashRoute,
  UsageRoute: UsageRoute,
  FilesIdRoute: FilesIdRoute,
  FoldersIdRoute: FoldersIdRoute,
  GroupsIdRoute: GroupsIdRoute,
  GroupsIndexRoute: GroupsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
